var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 3.00016C8.07697 3.02792 4.5 6.62155 4.5 11.0505C4.5 15.841 8.68859 18.8593 11.0236 20.2104C11.9255 20.7322 13.0745 20.7322 13.9764 20.2104C16.3114 18.8593 20.5 15.841 20.5 11.0505C20.5 6.62155 16.923 3.02792 12.5 3.00016ZM12.5 3.00016C12.5172 3.00005 12.5344 3 12.5516 3H12.4484C12.4656 3 12.4828 3.00005 12.5 3.00016ZM16.5 11C16.5 13.2091 14.7091 15 12.5 15C10.2909 15 8.5 13.2091 8.5 11C8.5 8.79086 10.2909 7 12.5 7C14.7091 7 16.5 8.79086 16.5 11Z",
    stroke: "#03045E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.bb29ac5019dc7f819ab263ea318154a2.svg";
export { ForwardRef as ReactComponent };